export const FileDropZoneQa = {
    DESCRIPTION: 'file_drop_zone-description',
    TITLE: 'file_drop_zone-title',
    BUTTON: 'file_drop_zone-button',
    ICON: 'file_drop_zone-icon',
    FILE_INPUT: 'file_drop_zone-input',
} as const;
